<div class="modal-header">
  <h4 class="modal-title pull-left">
    @if (isActivityMode()) {
      {{ 'RAPPORT_TIR.DELIVERIES_REPORT' | translate }}
    } @else {
      {{'GLOBAL.TIR' | translate}}
    }
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form #form="ngForm" id="myForm" (ngSubmit)="onSubmit(form.value.nomTir)">
    @if (areReportTypesLoaded()) {
      <div class="form-group">
        <label id="selectReportLabel">{{'RAPPORT_TIR.SELECT_REPORT' | translate}}</label>
        <ng-select aria-labelledby="selectReportLabel"
          id="selectReport"
          name="selectReport"
          [items]="reportTypes()"
          bindLabel="name"
          [(ngModel)]="selectedReport"
          [addTag]="true"
          [hideSelected]="false"
          [multiple]="false"
          [closeOnSelect]="true"
          [clearable]="false"
          >
        </ng-select>
        @if (reportTypeInvalid()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    }

    @if (selectedReport()?.type !== 6) {
      <div class="form-group">
        <label id="nomTirLabel">{{'GLOBAL.NOM' | translate}}</label>
        <input aria-labelledby="nomTirLabel" id="nomTir" type="text" [(ngModel)]="nomRapport" name="nomTir" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" maxlength="150" autocomplete="off" />
        @if (nomInvalide()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    }

    @if (selectedReport()?.type === 1) {
      <div class="form-group">
        <label id="selectTemplateLabel">{{'RAPPORT_TIR.SELECT_TEMPLATE' | translate}}</label>
        <ng-select aria-labelledby="selectTemplateLabel"
          id="selectTemplate"
          name="selectTemplate"
          [items]="reportsTemplates()"
          bindLabel="templateName"
          [(ngModel)]="selectedTemplate"
          [addTag]="true"
          [hideSelected]="false"
          [multiple]="false"
          (change)="selectedTemplateChange()"
          (clear)="selectedTemplateClear()"
          [ngClass]="{'error-value-select': showError()}"
          [closeOnSelect]="true"
          [clearable]="false"
          >
        </ng-select>
        @if (templateInvalid()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    }

    @if (selectedReport()?.type === 1 && isBlastFRTemplate()) {
      <div class="form-group">
        <label for="selectDestination">{{'Select hole name'}}</label>
        <ng-select name="selectDestination"
          id="selectDestination"
          [items]="holesNames()"
          bindLabel="name"
          [(ngModel)]="selectedHoleName"
          [addTag]="true"
          [hideSelected]="false"
          [multiple]="false"
          [closeOnSelect]="true">
        </ng-select>
      </div>
    }

    @if (selectedReport()?.type === 1 && isBlastFRTemplate()) {
      <div class="form-group">
        <input type="file" #fileSelect  accept="image/jpeg, image/png, image/svg" (change)="onFileSelected($event)" />
      </div>
    }

    @if (selectedReport()?.type === 6) {
      <div class="form-group">
        <label id="vibrationStartDateLabel">Start date</label>
        <input
          aria-labelledby="vibrationStartDateLabel"
          id="vibrationStartDate"
          type="date"
          [(ngModel)]="vibrationStartDate"
          name="vibrationStartDate"
          class="form-control"
          autocomplete="off"
        />
      </div>

      <div class="form-group">
        <label id="vibrationEndDateLabel">End date</label>
        <input
          aria-labelledby="vibrationEndDateLabel"
          id="vibrationEndDate"
          type="date"
          [(ngModel)]="vibrationEndDate"
          name="vibrationEndDate"
          class="form-control"
          autocomplete="off"
        />
      </div>
    }


    @if (selectedReport()?.type === 3) {
      <div  class="form-deliveries">
        @if (isActivityMode()) {
          <div class="form-group form-custom report-time-range-row">
            <div class="report-time-range-field">
              <label id="activityStartTimeLabel">Start time</label>
              <select
                aria-labelledby="activityStartTimeLabel"
                id="activityStartTime"
                name="activityStartTime"
                class="form-control"
                [(ngModel)]="activityStartTime"
              >
                <option value="">--</option>
                @for (startTime of startTimeOptions(); track startTime) {
                  <option [value]="startTime">{{ startTime }}</option>
                }
              </select>
            </div>

            <div class="report-time-range-field">
              <label id="activityEndTimeLabel">End time</label>
              <select
                aria-labelledby="activityEndTimeLabel"
                id="activityEndTime"
                name="activityEndTime"
                class="form-control"
                [(ngModel)]="activityEndTime"
              >
                <option value="">--</option>
                @for (endTime of endTimeOptions(); track endTime) {
                  <option [value]="endTime">{{ endTime }}</option>
                }
              </select>
            </div>
          </div>

          <div class="form-group form-custom">
            <label id="selectDateLabel">{{ 'RAPPORT_TIR.SELECT_DATE' | translate }}</label>
            <ng-select aria-labelledby="selectDateLabel"
              id="selectDate"
              name="selectDate"
              [items]="deliveries()"
              [ngModel]="selectedDeliveries()"
              (ngModelChange)="onActivityDeliveriesChange($event)"
              [addTag]="false"
              [hideSelected]="false"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearable]="true"
              >
              <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{ item.startTime | date:'dd/MM/yyy HH:mm' }} - {{ item.name }}
              </ng-template>
            </ng-select>
          </div>
        } @else {
          <div class="form-group form-custom" >
            <label id="selectDateLabel">{{'RAPPORT_TIR.SELECT_DATE' | translate}}</label>
            <ng-select aria-labelledby="selectDateLabel"
              id="selectDate"
              name="selectDate"
              [items]="deliveries()"
              (change)="onSelectReportType($event)"
              [addTag]="true"
              [hideSelected]="false"
              [multiple]="false"
              [closeOnSelect]="true"
              [readonly]="selectedAllDeliveries()"
              >
              <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{ item.startTime | date:'dd/MM/yyy HH:mm' }}
              </ng-template>
            </ng-select>
          </div>
          <div class="form-deliveries-checkbox">
            <label id="checkbox-select-all-Label">{{'RAPPORT_TIR.SELECT_ALL' | translate}}</label>
            <input aria-labelledby="checkbox-select-all-Label" id="checkbox-select-all" name="checkbox-select-all" type="checkbox"  [(ngModel)]="selectedAllDeliveries"/>
          </div>
        }
        @if (deliveriesSelectionInvalid()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    }

    @if (!isActivityMode() && selectedReport()?.type !== 1) {
      <div class="form-group">
        <label id="selectDestinationLabel">{{'RAPPORT_TIR.DESTINATION' | translate}}</label>
        <ng-select aria-labelledby="selectDestinationLabel"
          id="selectDestination"
          name="selectDestination"
          [items]="workflowSteps()"
          bindLabel="nom"
          [(ngModel)]="selectedWorkflowStep"
          [addTag]="true"
          [hideSelected]="false"
          [multiple]="false"
          [closeOnSelect]="true">
        </ng-select>
        @if (destinationInvalide()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
    }


    @if (erreurApi()) {
      <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
    }
    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        @if (selectedReport()?.type != 1) {
          <button type="submit" class="btn btn-outline-success" style="margin-right:10px;" [disabled]="isSubmitting()">{{'GLOBAL.VALIDER' | translate}}</button>
        }
        
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{'GLOBAL.ANNULER' | translate}}</button>
      </div>
    </div>
  </form>

</div>


<div id="screen-shot">

  <app-holecharge-view [holeChargeView]="holeChargeView()">
  </app-holecharge-view>

</div>





